import React from 'react';

import { Modal, Row, Col, Image as BootstrapImage, Dropdown, MenuItem, Media } from 'react-bootstrap';

import { ToolBar, ToolBarGroup } from 'src/legacy/components/ToolBar/ToolBar.jsx';
import { ToolBarButtonItem } from 'src/legacy/components/ToolBar/ToolBarButtonItem.jsx';

import cx from 'classnames';
import Button from 'src/legacy/components/Button';
import styles from './styles.module.scss';
import CropImageView from './crop';
import _ from "lodash";
import { localizedStrings } from 'src/localization/index.jsx';

const LoadingIcon = '/images/loading_plane.gif'
class AssetIconEditor extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      image: this.props.image,
      src: null,
      originalImage: this.props.image,
      show: this.props.show,
      showCropEditor: false,
      canCrop: false,
      crop: props.crop || {
        x: 0,
        y: 0,
        width: 100,
        height: 100,
        unit: "%"
      },
      cropType: props.cropType || 'reactangle',
      width: this.props.width,
      height: this.props.height,
      fetching: true
    }

    this.handleCropClicked = this.handleCropClicked.bind(this);
    this.onCropChange = this.onCropChange.bind(this);

    this.onResetClick = this.onResetClick.bind(this);
    this.onUploadClick = this.onUploadClick.bind(this);

     // localized contents
     this.localizedCommons = localizedStrings.commons;
     this.localizedCommonLoading = this.localizedCommons.loading;
     this.localizedCommonActions = this.localizedCommons.actions;
  }
  
  componentDidMount(){
    this.loadImage(this.props.image).then(image => {
      var dataImage = this.getDataURL(image, this.state.crop);
      var dimension = this.calculateBannerDimension({
        width: dataImage.width,
        height: dataImage.height
      });

      this.setState({
        src: dataImage.src,
        originalSrc: dataImage.src,
        ...dimension
      },() => {
        this.setState({
          fetching : false 
        })
      });
    })
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.show != this.props.show){
      this.setState({
        image: nextProps.image,
        canCrop: true,
      })
    }
  }  

  onUploadClick(){
   
    const collectioName = _.get(this.props, 'collectioName');
   this.props.trackAdoptionMetricsForAddLogoUploadClickedEvent(collectioName);
    if(this.props.onChange){
      this.props.onChange(this.state.src);
    }
  }

  onResetClick(){
    if(this.props.onCancel){
      this.props.onCancel();  
    }
  }

  handleCropClicked(){
    this.setState({
      showCropEditor: true
    })
  }

  onCropChange(crop){
    this.loadImage(this.state.originalSrc).then(image => {
      var dataImage = this.getDataURL(image, crop);
      var dimension = this.calculateBannerDimension({
        width: dataImage.width,
        height: dataImage.height
      });

      this.setState({
        src: dataImage.src,
        crop: crop,
        imageLoading: false,
        showCropEditor: false,
        backgroundUpdated: true,
        ...dimension
      })
    });
  }

  isDataURL(str) {
    if (str === null) {
      return false
    }
    const regex = /^\s*data:([a-z]+\/[a-z]+(;[a-z-]+=[a-z-]+)?)?(;base64)?,[a-z0-9!$&',()*+;=\-._~:@/?%\s]*\s*$/i
    return !!str.match(regex)
  }

  getDataURL(image, crop){
    var canvas = document.createElement("canvas");
    var width = image.width;
    var height = image.height;

    if(image.width > 1600){
      var resizedCanvas = this.resizeImage(image, 1600);
      image = resizedCanvas;
      width = resizedCanvas.width;
      height = resizedCanvas.height;
    }

    var sx = (width * crop.x) / 100;
    var sy = (height * crop.y) / 100;
    var sWidth = (width * crop.width) / 100;
    var sHeight = (height * crop.height) / 100;
    var aspectRatio = sWidth / sHeight;

    canvas.width = sWidth;
    canvas.height = sHeight;

    var ctx = canvas.getContext("2d");
    ctx.drawImage(image, sx, sy, sWidth, sHeight, 0, 0, sWidth,  sHeight);

    return {
      src: canvas.toDataURL("image/png", 1),
      width: sWidth,
      height: sHeight
    }
  }

  resizeImage(image, width){
    const canvas = document.createElement("canvas");
    var ctx = canvas.getContext("2d");

    var scaleX = image.width / width;

    var dimension = {
      width: Math.floor(image.width * 0.5),
      height: Math.floor(image.height * 0.5)
    }

    canvas.width = dimension.width;
    canvas.height = dimension.height;
    ctx.drawImage(image, 0, 0);

    while (canvas.width * 0.5 > width) {
      dimension = {
        width: Math.floor(dimension.width * 0.5),
        height: Math.floor(dimension.height * 0.5)
      };

      canvas.width = width;
      canvas.height = canvas.width * image.height / image.width;
      ctx.drawImage(canvas, 0, 0, dimension.width * 2, dimension.height * 2, 0, 0, dimension.width, dimension.height);
    }

    canvas.width = width;
    canvas.height = canvas.width * image.height / image.width;
    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

    return canvas;
  }

  loadImage(image){
    if (typeof File !== 'undefined' && image instanceof File) {
      return this.loadImageFile(image).then(url => {
        return this.loadImageURL(url)
      });
    } else if (typeof image === 'string') {
      return this.loadImageURL(image);
    }
  }

  loadImageURL(imageURL) {
    return new Promise((resolve, reject) => {
      const image = new Image()
      image.onload = () => resolve(image)
      image.onerror = reject
      if (this.isDataURL(imageURL) === false) {
        image.crossOrigin = 'anonymous'
      }

      image.src = imageURL
    })
  }

  loadImageFile (imageFile) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = e => resolve(e.target.result)
      reader.onerror = reject
      reader.readAsDataURL(imageFile)
    });
  }

  calculateBannerDimension(dimension){
    var width = dimension.width;
    var height = dimension.height;
    const ratio = width / height;

    var landscape = width > height;
    if(landscape){
      width = Math.max(width, 400);
      width = Math.min(width, 800);

      height = width / ratio;

    }else{
      height = Math.max(height, 400);
      height = Math.min(height, 600);

      width = height * ratio;
    }

    return {
      width, height
    }
  }

  render(){
    return (
      <div>
        <Modal show={this.state.show && !this.state.addNewBanner} 
          keyboard={true}
          backdrop={true} 
          dialogClassName={cx(styles.dialog, this.props.className)}
        >
          <Modal.Body className={cx(styles.modalBody,{
              [styles.disabledModal] : this.state.fetching
            })} >
            {this.renderImageView()}  
            {this.state.showCropEditor &&
              <CropImageView src={this.state.originalSrc} 
                crop={this.state.crop}
                entity = {this.props.entity}
                source={_.get(this.props, "source")}
                cropType={this.state.cropType}
                dimension={{
                  width: this.state.width,
                  height: this.state.height
                }}
                onCrop={this.onCropChange}
                onCancel={() => {
                  this.setState({
                    showCropEditor: false
                  })
                }}
              />
            }
          </Modal.Body>
        </Modal>
      </div>
    );
  }

  renderToolbar(){
    return (
      <ToolBar>
        <ToolBarGroup direction="left">
          <ToolBarButtonItem
              disabled={this.state.fetching}
              className={cx(styles.action)}
              width="auto" height="auto"
              onClick={this.handleCropClicked}>
              <span className={styles.actionButton}><span className={cx("fa fa-crop", styles.icon,{
              [styles.disabledIcon] : this.state.fetching
            })}></span>{this.localizedCommons.crop}</span>
          </ToolBarButtonItem>
        </ToolBarGroup>
      </ToolBar>
    );
  }

  renderImageView(){
    if(this.state.showCropEditor){
      return false;
    }

    var style = {
      width: this.state.width,
      height: this.state.height
    }

    return (
      <div className={cx(styles.editor)}>
        {this.renderToolbar()}
        
        <div className={styles.inner} style={style}>
        {!this.state.fetching && this.renderImage()}
        {this.state.fetching && <div className={styles.loadingThumbnail}>
          <BootstrapImage src={LoadingIcon} />
          <div className={styles.message}>{`${this.localizedCommonLoading.thumbnail}`}...</div>
        </div>}
        </div>
          
        <Button.Tray className={styles.buttonTray}>
          <Button 
            primary
            title={this.localizedCommonActions.upload}
            disabled={this.state.fetching}
            className={styles.buttonUpload} 
            onClick={this.onUploadClick}>
            </Button>
            <Button 
            title={this.localizedCommonActions.cancel}
            className={ cx(styles.buttonReset, {
              [styles.disabledButton] : this.state.fetching
            }) } 
            onClick={ this.onResetClick }>
          </Button>
        </Button.Tray>
      </div>
    );
  }

  renderImage(){
    var style = {
      'backgroundImage': `url("${this.state.src}")`
    };

    return (
      <div className={styles.top} style={style}></div>
    );
  }
}

AssetIconEditor.defaultProps = {
  
};

export default AssetIconEditor;